import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './FollowUpPlan.i18n';

export const configPlanDetails = (followUpPlan) => {
  const { templates, displayStartDate, memoToPatient } = followUpPlan;

  const instructions = !memoToPatient ? null : (
    <p>
      <strong><FormattedMessage { ...messages.planDetails.instructions } />&nbsp;</strong>{ memoToPatient }
    </p>
  );

  const guidelines = !templates || (templates && templates.length === 0) ? null : (
    <div>
      <strong><FormattedMessage { ...messages.planDetails.guidelines } /></strong>
      <ul>
      {
        templates.map((template, index) =>
          (
            <li key={ `key-${index}` }>
              <FormattedMessage values={{
                templateDisplayName: template.templateDisplayName,
                displayEffectiveDate: template.displayEffectiveDate.datePart,
              }}
                { ...messages.planDetails.template }
              />
            </li>
          ))
      }
      </ul>
    </div>
  );

  const planDetails = ({
    popoverTitle: (<FormattedMessage { ...messages.planDetails.title } />),
    triggerComponent: (
      <button className="btn btn-link theme float-right mt-4 mr-1 html-popover">
        <span className="fa-solid fa-circle-info mr-1" />
        <FormattedMessage { ...messages.planDetails.details } />
      </button>),
    popoverComponent: (
      <div>
        <p>
          <strong><FormattedMessage { ...messages.planDetails.startDate } />&nbsp;</strong>{ displayStartDate.datePart }
        </p>
        { instructions }
        { guidelines }
      </div>),
  });

  return planDetails;
};


export const configFilter = (filter) => ({
  value: filter || 'All',
  id: 'date-filter-input-group',
  filterConfig: [
    {
      filterTitle: <FormattedMessage { ...messages.filter.all } />,
      filterValue: 'All',
    },
    {
      filterTitle: <FormattedMessage { ...messages.filter.upcoming } />,
      filterValue: 'Upcoming',
    },
  ],
});
